import React, {useRef} from 'react';
import {inject, observer} from 'mobx-react';
import {aiAssistantEmptyAvatar} from '../../../../assets/images/';
import {generateAIVideosText} from '../../GenerateAIVideo/generateAIVideosText';

interface Props {
  file?: File;
  onFileSelected: (file?: File) => void;
  existingFileUrl?: string;
  onAvatarDelete: () => void;
}

const AvatarLibrary: React.FC<Props> = ({
  file,
  onFileSelected,
  existingFileUrl,
  onAvatarDelete,
}) => {
  const inputFile = useRef<any>(null);

  const onBrowse = () => {
    if (inputFile.current) {
      inputFile.current.value = '';
      inputFile.current.click();
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file?.type.includes('image')) {
      return;
    }
    if (file) {
      onFileSelected(file);
    }
  };

  return (
    <div className="AvatarInputContainer">
      <div className="GenerateAIAssistantThumb">
        <div className="LibraryFilesButtonContainer">
          <button onClick={onBrowse} className="BrowseButton">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : existingFileUrl
                  ? existingFileUrl
                  : aiAssistantEmptyAvatar
              }
              alt="Avatar"
              className={!file && !existingFileUrl ? 'PlaceholderAvatar' : ''}
            />
            {!file && !existingFileUrl && (
              <span className="icon-image-mount"></span>
            )}
          </button>

          <input
            type="file"
            onChange={onChange}
            accept="image/jpg,image/jpeg,image/png"
            style={{display: 'none'}}
            ref={inputFile}
          />
        </div>
      </div>
      {!file && !existingFileUrl && (
        <button className="DeleteImageButton" onClick={onBrowse}>
          {generateAIVideosText.changeIcon}
        </button>
      )}
      {(file || existingFileUrl) && (
        <button className="DeleteImageButton" onClick={onAvatarDelete}>
          {generateAIVideosText.delete}
        </button>
      )}
    </div>
  );
};

export default inject('myLibraryModalStore')(observer(AvatarLibrary));
